// extracted by mini-css-extract-plugin
export default {"root":"CustomTag_root__BOKf4"};